var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_vm._m(0),_c('div',{ref:"graphContainer",staticClass:"graph-container"})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home-header"},[_c('span',{staticClass:"home-tip"},[_vm._v("按住 Ctrl / ⌘ + 滚轮可缩放，拖拽画布可平移")])])
}]

export { render, staticRenderFns }